import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U2201, { U2201ROLES } from './U2201';
import U2201JobScheduleList from './components/U2201JobScheduleList';
import U2201JobScheduleForm from './components/U2201JobScheduleForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2201Routes: RouteObject[] = [
  {
    path: 'U2201',
    element: <U2000RequireRole allowedRoles={[U2201ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U2201 />,
        children: [
          { index: true, element: <U2201JobScheduleList /> },
          { path: ':id', element: <U2201JobScheduleForm /> },
        ],
      },
    ],
  },
];

export default U2201Routes;
